import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MessService } from 'src/app/_services/mess-service.service';
import { OnlineNipsService } from 'src/app/_services/online-nips.service';
import { OnlineNipFieldsService } from '../online-nip-fields.service';

@Component({
  selector: 'app-online-nip',
  templateUrl: './online-nip.component.html',
  providers: [DatePipe],
})
export class OnlineNipComponent implements OnInit, OnDestroy {
  onlineNips: {
    data: any[];
    pagination: any;
  } = {
    data: null,
    pagination: null,
  };
  subscriptions: Subscription[] = [];
  loading = false;
  showProductInfo = false;
  showFinalDetailsInfo = false;
  productInfo: any;
  finalDetailsInfo: any;
  existOperations: any;
  sortQuery = '';

  constructor(
    private onlineNipsService: OnlineNipsService,
    public fieldsService: OnlineNipFieldsService,
    private datePipe: DatePipe,
    private messService: MessService,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.getData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getData(pageIndex = 1, perPage = 100, queryParams = '') {
    this.loading = true;

    this.onlineNipsService
      .getActiveNips(pageIndex, perPage, queryParams, this.sortQuery)
      .subscribe({
        next: (responseData: any) => {
          this.existOperations = responseData.exist_operations;
          this.onlineNips.data = responseData.data.map((nip) => {
            return {
              ...nip,

              productDetails: {
                type: 'buttons',
                elements: [
                  {
                    tooltip: 'Detalji proizvoda',
                    icon: 'pi pi-folder',
                    action: () => {
                      this.onPreviewProductDetails(nip);
                    },
                  },
                ],
              },
              finalProcess: {
                type: 'buttons',
                elements: [
                  {
                    tooltip: 'Detalji završnog procesa',
                    icon: 'pi pi-align-left',
                    action: () => {
                      this.onPreviewFinalDetails(nip);
                    },
                  },
                ],
              },
            };
          });

          this.onlineNips.pagination = responseData.pagination;
          this.loading = false;
        },
        error: (err) => {
          if (err.status === 401) {
            this.authService.logout().subscribe(() => {
              this.router.navigate(['/login']);
            });
          }
        },
      });
  }

  /* ====================================
 *                HELPERS
 ======================================= */

  onPageChange(event: any) {
    this.getData(event.page + 1, event.rows);
  }

  onSort(event) {
    this.sortQuery = event.query;
    this.getData();
  }
  onPreviewProductDetails(onlineNipData) {
    this.productInfo = [onlineNipData];
    this.showProductInfo = true;
  }

  onPreviewFinalDetails(onlineNipData) {
    this.finalDetailsInfo = [onlineNipData.operations];

    this.showFinalDetailsInfo = true;
  }

  createBackground(item, parentIndex) {
    const dataArray = Object.values(this.finalDetailsInfo[0]);

    let color = '';

    if (item?.total_completed_percent === 100) {
      color = 'nip-background-priority-1';
    }

    if (
      item?.total_completed_percent > 0 &&
      item?.total_completed_percent < 100
    ) {
      color = 'nip-background-priority-4';
    }

    if (item?.total_completed_percent === 0) {
      let haveValue = false; // pretpostavka da su sve nula
      dataArray.forEach((element: any, index) => {
        if (parentIndex < index) {
          if (
            element?.total_completed_percent > 0 &&
            element?.total_completed_percent < 100
          ) {
            haveValue = true;
          }
        }
      });

      if (haveValue) {
        color = 'nip-background-priority-1';
      } else {
        color = 'nip-background-priority-2 ';
      }
    }

    return color;
  }

  onExportCsv() {
    this.loading = true;
    this.subscriptions.push(
      this.onlineNipsService.exportToCSV().subscribe((pdfHref) => {
        window.open(pdfHref.data, '_blank');
        this.loading = false;
      })
    );
  }
}
